<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="marginTop">
        <div class="bg-light">
          <v-toolbar color="primary" class="top-hero6" dark flat>
            <v-toolbar-title>Manage Houses</v-toolbar-title>
          </v-toolbar>

          <v-slide-group elevation="10" multiple show-arrows>
            <!-- <Pano source="https://vqv360images.s3.amazonaws.com/house.JPG"></Pano> -->
            <!-- <Pano source="https://vqv360images.s3.amazonaws.com/360.jpeg"></Pano> -->

            <v-slide-item v-for="rental in inventories" :key="rental.id">
              <div>
                <v-card
                  class="shadow ma-4"
                  min-height="450"
                  width="400"
                  color="grey lighten-4"
                >
                  <!-- <Pano v-if="rental.images" :source="rental.images[0].image_path"></Pano> -->

                  <v-img :src="rental.Images[0]"> </v-img>

                  <v-card-text>
                    <v-btn
                      absolute
                      color="blue"
                      class="white--text"
                      style="margin-top: 3em"
                      fab
                      large
                      right
                      top
                      @click="edit(rental.ListingKeyNumeric)"
                    >
                      <v-icon>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>

                    <h3 class="display-1 font-weight-light blue--text mb-2">
                      {{ rental.StreetNumber }}
                      {{ rental.StreetName }}
                      {{ rental.StreetSuffix }}
                    </h3>
                    <v-divider></v-divider>

                    <div class="flex flex-col">
                      <div class="-my-2 sm:-mx-6 lg:-mx-8">
                        <div
                          class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                        >
                          <div
                            class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                          >
                            <table class="min-w-full divide-y divide-gray-200">
                              <thead class="bg-gray-50">
                                <tr>
                                  <th
                                    scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                  >
                                    360 Resource
                                  </th>
                                  <th
                                    scope="col"
                                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                  >
                                    Type
                                  </th>

                                  <th scope="col" class="relative px-6 py-3">
                                    <span class="sr-only">remove</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <!-- Even row -->
                                <tr
                                  v-for="panoramic in rental.PanoImages"
                                  :key="panoramic.id"
                                  class="bg-gray-50"
                                >
                                  <!-- <td
                                    class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                  >
                                    {{ panoramic.mls_id }}
                                  </td> -->

                                  <td
                                    class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                  >
                                    <v-switch
                                      @change="updateMls(panoramic)"
                                      v-model="panoramic.enable"
                                      inset
                                    ></v-switch>
                                  </td>

                                  <td
                                    class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                                  >
                                    {{ panoramic.media_type }}
                                  </td>
                                  <td
                                    class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                                  >
                                    <a
                                      @click="removeMedia(panoramic.id)"
                                      class="cursor-pointer text-indigo-600 hover:text-indigo-900"
                                      >remove</a
                                    >
                                  </td>
                                </tr>

                                <!-- More people... -->
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-slide-item>
          </v-slide-group>

          <!-- Modal -->
          <!-- This example requires Tailwind CSS v2.0+ -->
          <div class="fixed z-10  inset-0 overflow-y-auto" v-if="isOpen">
            <div
              class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
              <div class="fixed inset-0 transition-opacity" aria-hidden="true">
                <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
              </div>

              <!-- This element is to trick the browser into centering the modal contents. -->
              <span
                class="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
                >&#8203;</span
              >

              <div
                :class="imageUrl.length > 0 ? 'w-5/12 ' : 'w-3/12'"
                class="inline-block bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all align-middle"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
              >
                <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <h3
                    class="text-lg leading-6 font-medium text-gray-900"
                    id="modal-headline"
                  >
                    Add Resources
                  </h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500">
                      Images - Videos
                    </p>

                    <small> Listing Id: </small><b> {{ selected }} </b>

                    <div class="mt-2 mb-2 sm:mt-0 sm:col-span-2">
                      <input
                        type="text"
                        v-model="label"
                        placeholder="Name"
                        class="p-2 border-2 border-gray-300 border max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>

                    <div v-if="imageUrl.length > 0">
                      <div
                        class="mt-4 mb-2 grid grid-cols-1 gap-5 sm:grid-cols-3"
                      >
                        <div
                          v-for="img in imageUrl"
                          :key="img.name"
                          class="px-2 py-2 bg-white shadow rounded-lg overflow-hidden sm:p-4"
                        >
                          <template v-if="img.type == 'image/jpeg'">
                            <img
                              @click="removeItem(img)"
                              class="cursor-pointer h-36 w-full border border-gray-300 bg-white text-gray-300 object-cover"
                              :src="img.url"
                            />
                          </template>
                          <template v-else-if="img.type == 'video/mp4'">
                            <video
                              @click="removeItem(img)"
                              controls
                              muted
                              class="cursor-pointer h-36 w-full border border-gray-300 bg-white text-gray-300 object-cover"
                            >
                              <source :src="img.url" type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </template>
                        </div>
                      </div>

                      <label
                        @click="imageUrl = []"
                        for="file-upload"
                        class="relative mr-2 cursor-pointer bg-red-100 rounded-md font-medium text-red-600 hover:text-red-800 focus-within:outline-none"
                      >
                        <span>Clear</span>
                      </label>

                      <label
                        for="file-upload"
                        class="relative cursor-pointer bg-blue-100 rounded-md font-medium text-blue-600 hover:text-blue-800 focus-within:outline-none"
                      >
                        <span>Change</span>
                        <input
                          multiple="multiple"
                          id="file-upload"
                          @change="uploadFiles"
                          type="file"
                          class="sr-only"
                        />
                      </label>
                    </div>

                    <div v-else class="mt-1 sm:mt-0 sm:col-span-2">
                      <div
                        class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                      >
                        <div class="space-y-1 text-center">
                          <svg
                            class="mx-auto h-12 w-12 text-gray-400"
                            stroke="currentColor"
                            fill="none"
                            viewBox="0 0 48 48"
                            aria-hidden="true"
                          >
                            <path
                              d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <div class="flex text-sm text-gray-600">
                            <label
                              for="file-upload"
                              class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                            >
                              <span>Upload files</span>
                              <input
                                multiple="multiple"
                                id="file-upload"
                                @change="uploadFiles"
                                type="file"
                                class="sr-only"
                              />
                            </label>
                            <p class="pl-1">or drag and drop</p>
                          </div>
                          <p class="text-xs text-gray-500">
                            PNG, JPG, GIF up to 10MB
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
                    >
                      <button
                        @click="saveImages(selected)"
                        class="disabled:opacity-50 mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-primary text-white font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Save
                      </button>
                      <button
                        @click="closingModal"
                        type="button"
                        class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- close Modal -->
        </div>
      </div>
    </div>
  </div>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import { Pano } from "vuejs-vr";
export default {
  components: { Pano },
  data() {
    return {
      selected: {},
      isOpen: false,
      images: [],
      label: "360 Images",
      imageUrl: [],
      imageName: ""
    };
  },

  mounted() {
    this.$store.dispatch("getInventory");
  },

  computed: {
    inventories() {
      return this.$store.getters.inventories;
    },

    filteredItems() {
      return this.images.filter(value => {
        return value.name != this.imageName;
      });
    }
  },

  methods: {
    updateMls(mls) {
      window.axios
        .post("/api/mlsUpdate/" + mls.id, {
          enable: mls.enable
        })
        .then(() => {
          this.$store.dispatch("getInventory");
        });
    },

    removeItem(img) {
      //this remove the element from the preview images
      const filtersList = this.imageUrl.filter(element => element !== img);
      this.imageUrl = filtersList;

      //this sent the filter array for uploading
      const newImages = Array.from(this.images);
      const newFiltered = newImages.filter(
        element => element.name !== img.name
      );
      this.images = newFiltered;
    },

    uploadFiles(e) {
      this.images = e.target.files || e.dataTransfer.files;

      const files = e.target.files;
      files.forEach(file => {
        this.imageUrl.push({
          name: file.name,
          url: URL.createObjectURL(file),
          type: file.type
        });
      });
    },

    closingModal() {
      this.isOpen = false;
      this.selected = {};
      this.imageUrl = [];
    },

    edit(item) {
      this.selected = item;
      this.isOpen = true;
    },

    removeMedia(id) {
      window.axios.get("/api/removeMedia/" + id).then(() => {
        this.$store.dispatch("getInventory");
      });
    },

    saveImages(id) {
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };

      let filesImages = new FormData();

      $.each(this.images, function(key, image) {
        filesImages.append(`images[${key}]`, image);
      });

      filesImages.append("listingId", id);
      filesImages.append("label", this.label);

      window.axios.post("/api/inventory", filesImages, config).then(() => {
        alert("Inventory Created");
      });
    }
  }
};
</script>
